/**
 * Waypoint action options. Values must match the waypoint_action enum in
 * Supabase (kept in sync with PlanFormModal's copy of this list).
 */
export const WAYPOINT_ACTIONS = [
  { value: 'none', label: 'None' },
  { value: 'photo_45', label: '45 Photo' },
  { value: 'photo_90', label: '90 Photo' },
  { value: 'photo_360', label: '360 Photo' },
];
